import React from "react";
import { Helmet } from "react-helmet";
import LineUpComponent from "../components/LineUp";
import { LeafRed } from "../components/Artwork";
import styles from "./LineUp.module.css";

const LineUpPage = () => {
  return (
    <div className={styles.lineUpPage}>
      <Helmet>
        <title>LineUp</title>
      </Helmet>
      
      <div className={styles.lineUpContainer}>
        <LineUpComponent />
      </div>

      {/* Artwork components placed after content for higher z-index */}
      <div className={styles.artworkContainer}>
        <LeafRed 
          className={styles.artLeft} 
          style={{
            position: 'absolute', 
            zIndex: 5,
            left: '2%',
            top: '40%',
            width: '60px',
            maxWidth: '10%',
            display: 'block',
            opacity: 0.9
          }} 
        />
        <LeafRed 
          className={styles.artBottom} 
          style={{
            position: 'absolute', 
            zIndex: 5,
            left: '10%',
            bottom: '5%',
            width: '60px',
            maxWidth: '10%',
            display: 'block',
            opacity: 0.9
          }} 
        />
      </div>
    </div>
  );
};

export default LineUpPage;
